<template>
    <div>
        <v-btn
            icon
            dark
            small
            color="white"
            class="close-btn close-btn-left d-none d-md-block"
            elevation="1"
            @click="closeReading">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <UtilsContent @close-action="closeReading">
            <template v-slot:header>
                <div v-if="hasAudioAvailable" class="d-flex flex-column justify-center align-start">
                    <div class="d-flex flex-row justify-start align-center mb-4">
                        <img :src="musicImg" class="img-index mr-2" alt="" />
                        <div class="align-middle text-left line-height-100">
                            <p class="font-size-16 font-weight-bolder ma-0 text--primary">
                                {{ $t('bookReading.storyletter') }}
                            </p>
                            <small class="font-size-12">Read Aloud</small>
                        </div>
                    </div>
                    <!--  -->
                    <div class="d-flex flex-row w-100 bg-primary-30 pa-4 pb-0 rounded-top">
                        <div class="row ma-0 mb-3 justify-content-between align-center bg-white pl-4 pr-4 border-radius-1">
                            <div class="primary--text font-weight-bolder">
                                <label for="">{{ $t('bookReading.listen_read_aloud') }}</label>
                            </div>
                            <div class="primary-switch py-2">
                                <!-- <v-switch  color="#7764CA" v-model="isSwitchOn" @change="handleSwitchChange"></v-switch> -->
                                <v-btn icon @click="togglePlayback">
                                    <v-icon color="#7764CA" large>
                                        {{ isSwitchOn ? 'mdi-pause-circle' : 'mdi-play-circle' }}
                                    </v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </div>
                    <v-snackbar v-model="snackbar" :timeout="timeout" color="error" top>
                        <p class="font-size-16 font-weigth-regular mb-0">
                            {{ $t('bookReading.not_storyteller_data_found') }}
                        </p>
                        <template v-slot:action="{ attrs }">
                            <v-btn icon v-bind="attrs" @click="snackbar = false">
                                <v-icon class="white--text">mdi-close</v-icon>
                            </v-btn>
                        </template>
                    </v-snackbar>
                </div>
                <div v-else class="d-flex flex-column justify-center align-center pa-4">
                    <v-icon large color="grey lighten-1" class="mb-2">mdi-volume-off</v-icon>
                    <p class="font-size-16 text--secondary text-center mb-0">
                        {{ $t('bookReading.no_audio_available') }}
                    </p>
                </div>
            </template>
            <template v-slot:content>
                <div class="position-relative">
                    <div class="d-flex flex-column bg-primary-30 rounded-bottom px-4 pt-0 pb-2">
                        <v-row justify="start" align="start">
                            <v-col cols="12" class="d-flex flex-column justify-start align-start" v-if="hasAudioAvailable">
                                <span class="text--primary font-size-14">
                                    {{ $t('bookReading.choose_voice') }}
                                </span>
                                <v-btn-toggle
                                mandatory
                                color=""
                                v-model="voiceToSelect"
                                class="w-100 mt-1 btn-toggle--primary border-radius-1"
                                >
                                <v-btn
                                        v-for="voice of bookPageVoices"
                                        :value="voice.voice_provider_id"
                                        :key="voice.voice_provider_id"
                                        class="d-flex justify-center w-50 align-center font-weight-bold font-size-14 text-capitalize"
                                        :disabled="isSwitchOn"
                                        @click="playOrPauseVoiceDemo(voice.voice_provider_id)"
                                        >
                                        <span>{{ voice.name }}</span>
                                    </v-btn>
                                </v-btn-toggle>
                            </v-col>
                            <v-col cols="12" v-if="hasAudioAvailable">
                                <v-btn-toggle
                                mandatory
                                v-model="velocity"
                                background-color="white"
                                color="primary"
                                class="w-100 btn-toggle--primary border-radius-1"
                                >
                                <v-btn
                                v-for="(rate, index) of rates"
                                :key="index"
                                :value="rate"
                                class="col-4 pa-0 font-weight-bold font-size-14"
                                        plain
                                        :disabled="!hasAudioAvailable || isSwitchOn"
                                        @click="changeVelocity(rate)"
                                        >
                                        <span>{{ rate }}</span><small>x</small>
                                    </v-btn>
                                </v-btn-toggle>
                            </v-col>
                            <v-col cols="12" class="d-flex flex-column justify-start align-start" >
                                <VoiceVolumeSelector :disabled="isSwitchOn">
                                    <v-slider
                                    min="0"
                                    max="100"
                                    color="primary"
                                    height="15"
                                    hide-details
                                    v-model="volume"
                                    :disabled="!hasAudioAvailable || isSwitchOn"
                                    />
                                </VoiceVolumeSelector>
                            </v-col>
                        </v-row>
                    </div>
                    <div class="read-aloud-overlay" @click="alertPause" v-if="isSwitchOn"></div>
                    <v-alert
                        :value="alert"
                        color="#7764CAB2"
                        icon="mdi-alert-circle"
                        transition="scale-transition"
                        class="text-left read-aloud-alert"
                        dark
                        >
                        <span v-html="$t('bookReading.pause_read_aloud')"></span>
                    </v-alert>
                </div>
            </template>
        </UtilsContent>
    </div>
</template>
<script>


import UtilsContent from '@/components/core/utils/UtilsContent.vue'
import ReadAloudPreview from '@/components/core/utils/ReadAloudPreview.vue'
import VoiceVolumeSelector from '@/components/core/utils/VoiceVolumeSelector.vue'
import { mapActions, mapState } from "vuex";
import Markjs from '../../../mixins/Markjs'

export default {
    name: "ReadAloud",
    components: {
        UtilsContent,
        ReadAloudPreview,
        VoiceVolumeSelector,
    },
    data: () => ({
        musicImg: require('@/assets/img/icons/new-reading/read-aloud-purple.svg'),
        volume: 20,
        snackbar: false,
        timeout: 3000,
        audio: null,
        isSwitchOn: false,
        velocity: 1,
        rate: 1,
        rates: [0.7, 0.9, 1.0],
        alert: false,
        isAlerting: false,
        voiceToSelect: null,
    }),
    computed: {
        ...mapState({
            activeNarration: (state) => state.bookReading.activeNarration,
            pageAudio: (state) => state.bookReading.pageAudio,
            bookPageVoices: (state) => state.bookReading.bookPageVoices,
            currentVoice: (state) => state.bookReading.currentVoice,
        }),
        hasAudioAvailable() {
            return this.bookPageVoices && this.bookPageVoices.length > 0
        },
    },
    methods: {
        ...mapActions('bookReading', ['setCurrentVoice']),
        changeVelocity(rate) {
            this.rate = rate
        },
        playOrPauseVoiceDemo(voice) {
            if (this.audio && !this.audio.paused) {
                this.audio.pause()
            }
            const audio = new Audio(`${process.env.VUE_APP_VOICE_SAMPLE_URL}${voice}.mp3`);
            
            audio.playbackRate = this.rate || 1.0;
            audio.volume = this.volume / 100;

            audio.play()
                .then(() => {
                    this.audio = audio;
                })
                .catch(() => {
                    this.audio = null;
                });
        },
        togglePlayback() {
            this.isSwitchOn = !this.isSwitchOn;
            if (this.isSwitchOn) {
                this.readCurrentText();
            } else {
                this.pausePageAudioAndMark();
                this.alert = false
            }
        },
        alertPause() {
            if (this.isAlerting) { return }
            
            this.isAlerting = true
            this.alert = true
            setTimeout(() => {
                this.alert = false
                this.isAlerting = false
            }, 3000)
        },
    },
    watch: {
        activeNarration(newVal) {
            this.isSwitchOn = newVal
        },
        voiceToSelect(newVoice) {
            this.setCurrentVoice(newVoice)
        },
    },
    mixins: [Markjs]
}
</script>
<style lang="scss">
    .read-aloud-overlay{
        background: white;
        opacity: 0.1;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 10;
    }
    .read-aloud-alert.v-alert.v-sheet{
        border-radius: 8px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 11;
    }
</style>